import React from 'react';

const LuxuryCarRatesTable = () => {
  const luxuryRatesData = [
    {
      srNo: 1,
      carType: "Mercedes E – 200",
      fourHrRate: "6500",
      eightHrRate: "9500",
      extraKmRate: "95",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "700",
      nightHolt: "700",
      extraHrRate: "900",
    },
    {
      srNo: 2,
      carType: "Bmw 5 series",
      fourHrRate: "6500",
      eightHrRate: "9500",
      extraKmRate: "95",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "700",
      nightHolt: "700",
      extraHrRate: "900",
    },
    {
      srNo: 3,
      carType: "Audi A4",
      fourHrRate: "6000",
      eightHrRate: "8500",
      extraKmRate: "75",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "700",
      nightHolt: "700",
      extraHrRate: "800",
    },
    {
      srNo: 4,
      carType: "Toyota Fortuner",
      fourHrRate: "4700",
      eightHrRate: "6500",
      extraKmRate: "65",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "700",
      nightHolt: "700",
      extraHrRate: "800",
    },
    {
      srNo: 5,
      carType: "Honda Accord",
      fourHrRate: "4500",
      eightHrRate: "6000",
      extraKmRate: "60",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "600",
      nightHolt: "600",
      extraHrRate: "700",
    },
    {
      srNo: 6,
      carType: "Mitsubishi Pajero Sport",
      fourHrRate: "4500",
      eightHrRate: "6000",
      extraKmRate: "60",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "600",
      nightHolt: "600",
      extraHrRate: "700",
    },
    {
      srNo: 7,
      carType: "Toyota Altis",
      fourHrRate: "3200",
      eightHrRate: "4500",
      extraKmRate: "40",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "400",
      nightHolt: "400",
      extraHrRate: "450",
    },
    {
      srNo: 8,
      carType: "HONDA CITY",
      fourHrRate: "3200",
      eightHrRate: "4500",
      extraKmRate: "35",
      airportPickup: "Return Km",
      outstationKm: "300 KM",
      driverAllowance: "400",
      nightHolt: "400",
      extraHrRate: "350",
    },
  ];

  const tableStyle = {
    width: "100%",
    borderCollapse: "collapse",
    margin: "20px auto",
  };

  const thStyle = {
    backgroundColor: "#008000",
    color: "white",
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const tdStyle = {
    padding: "8px",
    border: "1px solid #ddd",
    textAlign: "center",
  };

  const trEvenStyle = {
    backgroundColor: "#f9f9f9",
  };

  return (
    <div className="container p-0">
      <h3>Luxury Car Local & Outstation Rates</h3>
      <div className="table-responsive">
        <table style={tableStyle}>
          <thead>
            <tr>
              <th style={thStyle}>Sr.No</th>
              <th style={thStyle}>Car Type</th>
              <th style={thStyle}>4 Hrs./ 40 Km.</th>
              <th style={thStyle}>8 Hrs. / 80 Km.</th>
              <th style={thStyle}>Extra Km Rate</th>
              <th style={thStyle}>Mumbai Airport Pick-up / Drop</th>
              <th style={thStyle}>Outstation use / 300 KM</th>
              <th style={thStyle}>Driver Allowance</th>
              <th style={thStyle}>Night Holt</th>
              <th style={thStyle}>Extra Hrs. Rate</th>
            </tr>
          </thead>
          <tbody>
            {luxuryRatesData.map((row, index) => (
              <tr key={index} style={index % 2 === 0 ? trEvenStyle : null}>
                <td style={tdStyle}>{row.srNo}</td>
                <td style={tdStyle}>{row.carType}</td>
                <td style={tdStyle}>{row.fourHrRate}</td>
                <td style={tdStyle}>{row.eightHrRate}</td>
                <td style={tdStyle}>{row.extraKmRate}</td>
                <td style={tdStyle}>{row.airportPickup}</td>
                <td style={tdStyle}>{row.outstationKm}</td>
                <td style={tdStyle}>{row.driverAllowance}</td>
                <td style={tdStyle}>{row.nightHolt}</td>
                <td style={tdStyle}>{row.extraHrRate}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LuxuryCarRatesTable;
